module.exports = __webpack_public_path__ + "img/formsDreieckGS.8521e9c2.svg";